import React from 'react';
import { makeStyles, createStyles, Card, CardHeader, CardActions } from '@material-ui/core';
import AcUnitIcon from '@material-ui/icons/AcUnit';
import { ThingCardProps } from './thing';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      minWidth: 100,
      minHeight: 110,
    },
    cardHeader: {
      marginBottom: -20,
    },
  })
);

export default function ThingHumiditySensor({ thing }: ThingCardProps) {
  const classes = useStyles();
  const { humidity } = thing.properties;
  if (typeof humidity !== 'number') {
    console.log('invalid humiditySensor:', thing);
    return <></>;
  }

  return (
    <Card className={classes.root}>
      <CardHeader
        avatar={<AcUnitIcon />}
        // action={<p>{humidity} %</p>}
        className={classes.cardHeader}
        title={thing.name}
      />
      <CardActions>
        <p>
          {humidity} %
          <br />
          Zuletzt aktualisiert: {thing.updatedAt.toLocaleString()}
        </p>
      </CardActions>
    </Card>
  );
}
